import React, { useState } from "react";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import styled from "styled-components";
import { toObjectLiteral } from "common/utils";
import { useSearchParams } from "react-router-dom";
import TimeEvolutionMetricsResult from "./Result";

const ControlsAndResultsLayout = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 20px;
`;

const ReloadButton = styled.div`
  grid-column: -2 / span 1;
  text-align: right;
  cursor: pointer;
`;

const IconRefresh = styled.i`
  color: #999;
  &:hover {
    color: #000;
  }
  transition: all 0.5s;
`;

const ResultsLayout = styled.div`
  margin: 0 25px 0 20px;
`;

const timePeriodOptions = [
  { label: "1 Day", value: "oneDay" },
  { label: "1 Week", value: "oneWeek" },
  { label: "1 Month", value: "oneMonth" },
  { label: "3 Months", value: "threeMonths" },
];

const metricOptions = [
  { label: "Average Speed", value: "averageSpeed" },
  { label: "Maximum Speed", value: "maxSpeed" },
  { label: "Latency", value: "latency" },
  { label: "Retransmissions", value: "retransmissions" },
  { label: "Active Flows", value: "activeFlows" },
  { label: "Flows Created Per Minute", value: "flowsCreated" },
  { label: "% Traffic at Max Speed", value: "traffic" },
  { label: "% Traffic in Congestion", value: "congestion" },
];

const entityOptions = [
  { label: "IP Address", value: "ip-address" },
  { label: "Subscriber ID", value: "subscriber-id" },
];

const TimeEvolutionMetrics = ({
  direction,
  subscribersToPlot,
  timePeriod,
  metric,
  selected
}) => {
  const [selTimePeriod, setSelTimePeriod] = useState(timePeriod || "oneDay");
  const [selMetric, setSelMetric] = useState(metric || "averageSpeed");
  const [entity, setEntity] = useState("ip-address");
  const [refreshSignal, setRefreshSignal] = useState(false);
  let [searchParams, setSearchParams] = useSearchParams();

  return (
    <>
      <ControlsAndResultsLayout>
        <ColumnsGrid columns={6} minWidth="15rem" rowGap="0">
          <SelectInputWithIcon
            title="Time Period"
            name="timePeriod"
            icon="date_range"
            selected={selTimePeriod}
            onChange={({ target }) => {
              setSelTimePeriod(target.value);
              setSearchParams({
                ...toObjectLiteral(searchParams),
                timePeriod: target.value,
              });
            }}
            options={timePeriodOptions}
          />
          <SelectInputWithIcon
            title="metric"
            name="metric"
            icon="insert_chart"
            selected={selMetric}
            onChange={({ target }) => setSelMetric(target.value)}
            options={metricOptions}
          />
          <SelectInputWithIcon
            title="entity"
            name="entity"
            icon="person"
            selected={entity}
            onChange={({ target }) => setEntity(target.value)}
            options={entityOptions}
          />
          <ReloadButton
            title="Refresh"
            className="context-menu header-dropdown m-r--5 button-reload-subs-groups-table"
            onClick={() => {
              setRefreshSignal(true);
            }}
          >
            <IconRefresh className="material-icons">refresh</IconRefresh>
          </ReloadButton>
        </ColumnsGrid>
      </ControlsAndResultsLayout>
      <ResultsLayout>
        <TimeEvolutionMetricsResult
          direction={direction}
          timePeriod={selTimePeriod}
          metric={selMetric}
          entity={entity}
          subscribersToPlot={subscribersToPlot}
          refreshSignal={refreshSignal}
          setRefreshSignal={setRefreshSignal}
          selected={selected}
        />
      </ResultsLayout>
    </>
  );
};

export default TimeEvolutionMetrics;